"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "corno-di-rosazzo": {
    "06dc975e": [{
      "hkey": "7411b882",
      "slug": "corno-di-rosazzo",
      "name": "Corno di Rosazzo",
      "primary": true,
      "skipSearch": false
    }],
    "s-andrat-dello-iudrio": [{
      "hkey": "7411b882",
      "slug": "corno-di-rosazzo",
      "name": "Corno di Rosazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0d3f6991": [{
      "hkey": "7411b882",
      "slug": "corno-di-rosazzo",
      "name": "Corno di Rosazzo",
      "primary": true,
      "skipSearch": false
    }],
    "visinale-dello-iudrio": [{
      "hkey": "7411b882",
      "slug": "corno-di-rosazzo",
      "name": "Corno di Rosazzo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;